import { useEffect, useState } from "react";

export const getOnlineStatus = () =>
  typeof navigator === "undefined" || navigator.onLine !== false;

export const isOffline = () => !getOnlineStatus();

export const queuedOfflineMessage =
  "Saved locally. This will sync automatically when you are back online.";

export const offlineStatusMessage =
  "You are offline. Changes you save now will be stored on this device and sync when you are back online.";

export const onlineAgainMessage =
  "Back online. Saved changes will sync automatically.";

export const offlineAwareMessage = (onlineMessage) =>
  isOffline() ? queuedOfflineMessage : onlineMessage;

export const useOnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(getOnlineStatus);

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const updateStatus = () => setIsOnline(getOnlineStatus());

    window.addEventListener("online", updateStatus);
    window.addEventListener("offline", updateStatus);
    updateStatus();

    return () => {
      window.removeEventListener("online", updateStatus);
      window.removeEventListener("offline", updateStatus);
    };
  }, []);

  return isOnline;
};

export const commitFirestoreWrite = async (
  writePromise,
  context = "Firestore write",
) => {
  if (isOffline()) {
    writePromise.catch((error) => {
      console.error(`${context} failed after being queued offline:`, error);
    });
    return { queued: true };
  }

  await writePromise;
  return { queued: false };
};
